import { render } from "./VCropper.vue?vue&type=template&id=5acae40b&scoped=true"
import script from "./VCropper.vue?vue&type=script&lang=js"
export * from "./VCropper.vue?vue&type=script&lang=js"

import "./VCropper.vue?vue&type=style&index=0&id=5acae40b&scoped=true&lang=css"

import exportComponent from "E:\\Projetos Web\\web-vida-vascular\\web-vidavascularjf-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acae40b"]])

export default __exports__